import * as Yup from 'yup';
import { rodnecislo } from 'rodnecislo';
import moment from 'moment';

export default Yup.object().shape({
  first_name: Yup.string().required('onboarding_personal_form_required'),

  last_name: Yup.string().required('onboarding_personal_form_required'),

  birth_number: Yup.string().when('country', {
    is: (value) => (value && value === 'SK') || (value && value === 'CZ'),
    then: Yup.string()
      .required('onboarding_personal_form_required')
      .test(null, 'onboarding_personal_form_bad_value', (inputValue) => {
        let rc = rodnecislo(inputValue);
        return rc.isValid();
      }),
    otherwise: Yup.string().required('onboarding_personal_form_required'),
  }),

  birth_date: Yup.string()
    .required('onboarding_personal_form_required')
    .test(null, 'onboarding_personal_form_not_adult', (val) => {
      const month = moment(val).format('MM');
      const year = moment(val).format('YYYY');
      const day = moment(val).format('DD');
      const isDate18orMoreYearsOld = (day, month, year) => {
        return new Date(Number(year) + 18, Number(month) - 1, Number(day)) <= new Date();
      };
      return isDate18orMoreYearsOld(day, month, year);
    })
    .nullable(),

  phone: Yup.string().when('country', {
    is: (value) => (value && value === 'SK') || (value && value === 'CZ'),
    then: Yup.string()
      .matches(
        /^((\+)(\d{3})([ ]?))((\d{3})([ ]?)){2}(\d{3})$/,
        'onboarding_personal_form_bad_value_phone'
      )
      .required('onboarding_personal_form_required'),
    otherwise: Yup.string().required('onboarding_personal_form_required'),
  }),

  email: Yup.string()
    .email('onboarding_personal_form_bad_value')
    .required('onboarding_personal_form_required')
    .nullable(),

  email_confirmation: Yup.string().when('email', {
    is: (val) => val && val.length > 0,
    then: Yup.string()
      .oneOf([Yup.ref('email')], 'onboarding_personal_form_email_match')
      .required('onboarding_personal_form_email_confirm_required'),
  }),

  country: Yup.string().required('onboarding_personal_form_required'),
  street: Yup.string().required('onboarding_personal_form_required'),
  house_number: Yup.string().required('onboarding_personal_form_required'),
  zip: Yup.string().when('country', {
    is: (value) => (value && value === 'SK') || (value && value === 'CZ'),
    then: Yup.string()
      .matches(/^(?=(\D*\d){5}\D*$)(?=[^ ]* ?[^ ]*$)[\d ]*$/, 'onboarding_personal_form_bad_value')
      .required('onboarding_personal_form_required'),
    otherwise: Yup.string().required('onboarding_personal_form_required'),
  }),

  city: Yup.string().required('onboarding_personal_form_required'),
  /* region: Yup.string().required(
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ), */
  entrepreneur: Yup.boolean().oneOf([true], 'onboarding_personal_form_required'),
});
